module.exports = __webpack_public_path__ + "img/img_crown_hover.513511f7.svg";